import React from "react";
import { Link } from "react-router-dom";

// ⚠️ Placeholder content — replace with real legal text before launch.
const PrivacyPolicy: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto p-6 md:p-10">
      <Link to="/login" className="text-blue-500 text-sm hover:underline">
        ← Retour
      </Link>
      <h1 className="text-2xl font-bold mt-4 mb-6">
        Politique de Confidentialité
      </h1>
      <p className="text-sm text-gray-500 mb-6">
        Dernière mise à jour : [à compléter]
      </p>

      <div className="prose prose-sm max-w-none text-gray-700 space-y-4">
        <p>
          <em>
            Ce texte est un espace réservé. Le contenu juridique définitif de la
            Politique de Confidentialité de RAJAPI-COP doit être fourni et
            validé avant la mise en production.
          </em>
        </p>
        <h2 className="text-lg font-semibold">1. Données collectées</h2>
        <p>
          RAJAPI-COP collecte les données nécessaires à la création et à la
          gestion du compte utilisateur, notamment le nom, l'email et le numéro
          de téléphone.
        </p>
        <h2 className="text-lg font-semibold">2. Utilisation des données</h2>
        <p>
          Les données collectées sont utilisées exclusivement dans le cadre du
          fonctionnement de la plateforme et ne sont pas cédées à des tiers sans
          consentement.
        </p>
        <h2 className="text-lg font-semibold">3. Droits de l'utilisateur</h2>
        <p>
          L'utilisateur peut demander l'accès, la rectification ou la
          suppression de ses données personnelles à tout moment.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
